import { Component, OnInit } from "@angular/core";
// import PerfectScrollbar from "perfect-scrollbar";
import { AuthService } from "../security/auth.service";
import { Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { GenericoService } from "../shared/services/generico.service";
import { Usuario } from "../security/entidades/usuario";
import { Global } from "../utilerias/clases-globales/global";
import Swal from "sweetalert2";
import { Menu } from "../shared/model/security/menu.model";

declare const $: any;

//Metadata
export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  collapse?: string;
  children?: ChildrenItems[];
}

export interface ChildrenItems {
  path: string;
  title: string;
  ab: string;
  type?: string;
}

@Component({
  selector: "app-sidebar-cmp",
  templateUrl: "sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
  standalone: false,
})
export class SidebarComponent implements OnInit {
  ps: any;
  public menuItems: Menu[];
  user: Usuario;
  sucursal: string;
  fotosidebar: any = "./assets/img/default-avatar.png";

  constructor(
    private authService: AuthService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private genericoService: GenericoService,
    private global: Global
  ) {}

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  ngOnInit() {
    let user = JSON.parse(localStorage.getItem("user"));
    this.menuItems = this.authService.getMenuList();

    if (user != undefined && user.usuario != null && user.usuario.sucursal) {
      this.user = user.usuario;
      this.sucursal = user.usuario.sucursal.nombre;
      this.persona();
    }

    // if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
    //   const elemSidebar = <HTMLElement>(
    //     document.querySelector(".sidebar .sidebar-wrapper")
    //   );
    // this.ps = new PerfectScrollbar(elemSidebar);
    // }
  }

  //   updatePS(): void {
  //     if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
  //       this.ps?.update();
  //     }
  //   }
  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0
    ) {
      bool = true;
    }
    return bool;
  }
  expandOrCollapseMenu(id) {
    let parent = document.getElementById(id + "-p");
    let child = document.getElementById(id);
    parent.ariaExpanded = parent.ariaExpanded === "true" ? "false" : "true";
    child.style.height =
      child.style.height === "0px" || child.style.height === "" ? "100%" : "0";
  }

  logout() {
    Swal.fire({
      text: this.user.nombre + ", ¿Estás seguro(a) de cerrar sesión?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, deseo salir",
      cancelButtonText: "Continuar...",
      customClass: {
        confirmButton: "btn btn-default",
        cancelButton: "btn btn-success ",
      },
      buttonsStyling: false,
    }).then((reason) => {
      if (reason.value) {
        this.authService.logout();
        this.global.timeLeft = 0;
      }
    });
  }

  datosUsuario() {
    this.router.navigate(["usuarios/datosUsuarios"]);
  }

  // foto de persona
  persona() {
    this.genericoService.consultpersonfoto().subscribe((res: any) => {
      if (res.byteLength != 0) {
        let arreglo = new Uint8Array(res);
        let imgtxt: string = "";
        new Uint8Array(arreglo).forEach(function (byte: number) {
          imgtxt += String.fromCharCode(byte);
        });
        let base64Img = btoa(imgtxt);
        this.fotosidebar = this.sanitizer.bypassSecurityTrustUrl(
          "data:image/jpg;base64," + base64Img
        );
      }
    });
  }
}
